import { CollectionExpression } from "../../Models/CollectionExpression";
import { IExpressionEvaluator } from "../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";

export class CollectionExpressionEvaluator implements IExpressionEvaluator<CollectionExpression> {
    get type(): string {
        return "Collection";
    }

    evaluate(expression: CollectionExpression, context: IExpressionEvaluatorContext): MaybePromise<any[]> {
        const items: any[] = [];
        let hasPromise = false;

        for (const item of expression.Items) {
            const itemValue = context.Evaluator.evaluate(item, context);
            items.push(itemValue);

            if (!hasPromise && itemValue instanceof Promise) {
                hasPromise = true;
            }
        }

        // Only use Promise.all if at least one item is a Promise
        return hasPromise ? Promise.all(items) : items;
    }
}
